<!--
 * @Description: 教材单条查找带回
 * @Author: PF
 * @Date: 2023-02-03 15:00:22
 * @LastEditors: PF
 * @LastEditTime: 2025-11-05 09:07:44
-->
<template>
  <div class="jzg_insert">
    <el-dialog style="min-width: 770px;" class="wp70 hp70" :model-value="openDanTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">教材</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDanTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>

      <el-container>
        <el-header class="pl0 pr0">
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-input class="filter-item" v-model="dataGrid.parms.jcmc" placeholder="教材名称" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
        </el-header>
        <el-main class="pl0 pb0 pr0">
          <el-table :data="data" v-loading="dataGrid.loading" height="100%" border>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" width="80" fixed align="center" />
            <el-table-column prop="jcdm" label="教材代码" align="center" show-overflow-tooltip />
            <el-table-column prop="jcmc" label="教材名称" align="center" show-overflow-tooltip />
            <!-- 冻结列-Left END -->
            <el-table-column prop="cbh" label="出版号" align="center" show-overflow-tooltip />
            <el-table-column prop="bc" label="版次" align="center" show-overflow-tooltip />
            <el-table-column prop="dj" label="单价" align="center" show-overflow-tooltip />
            <el-table-column prop="kcsl" label="库存数量" align="center" show-overflow-tooltip />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="90" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" @click="savestudent(currentRow=scope.row)">选择</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDanTiao', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue'
import { loadSelect, closeWindow } from '@/api/common.js'
const props = defineProps({
  openDanTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDanTiao', 'ReturnData'])

const currentRow = ref()
const savestudent = () => {
  emits('ReturnData', currentRow.value)
  handleClose()
}
const handleClose = () => {
  emits('update:openDanTiao', false)
}
const data = ref([])
const dataGrid = ref({
  parms: {},
  data: [],
  loading: false
})
const bindTable = async () => {
  loadSelect({
    url: '/api/v2/jiaowu/kecheng/jiaocai',
    data: data,
    parms: dataGrid.value.parms
  })
}
watch(
  () => props.openDanTiao,
  () => {
    if (props.openDanTiao) {
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
</style>
